import * as React from 'react';
import isUserAtActivePolicies from '../selectors/getIsUserAtActivePolicies';
import getActivePoliciesListState from '../selectors/getActivePoliciesListState';
import getAvailablePoliciesListState from '../selectors/getAvailablePoliciesListState';
import { observer } from 'mobx-react';
import ActivePoliciesPage from './ActivePoliciesPage';
import AvailablePoliciesPage from './AvailablePoliciesPage';
import { onRetentionPoliciesFullInitialized } from '../actions/internalActions';

@observer
export default class RetentionPoliciesFull extends React.Component<{}, {}> {
    constructor(props) {
        super(props);
        // Whenever user comes to retention policies page from outside settings or some other option, we want to fetch the data again from the server.
        // So we need to reset the isStale value to true here for both active and available policies.
        onRetentionPoliciesFullInitialized();
    }

    render() {
        return isUserAtActivePolicies() ? (
            <ActivePoliciesPage activePoliciesListState={getActivePoliciesListState()} />
        ) : (
            <AvailablePoliciesPage availablePoliciesListState={getAvailablePoliciesListState()} />
        );
    }
}
